/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import TOC from '@ember/component/template-only';

import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';

export interface ISkusSupplierFilterDefinitionArgs {
  skuId?: string;
  beforeQuery?: (query: IJsonApiQuery) => IJsonApiQuery;
}

interface FiltersSkusSupplierFilterSignature {
  Args: IFilterArgs<ISkusSupplierFilterDefinitionArgs>;
}

const FiltersSkusSupplierFilterComponent = TOC<FiltersSkusSupplierFilterSignature>();

export default FiltersSkusSupplierFilterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::SkusSupplierFilter': typeof FiltersSkusSupplierFilterComponent;
    'filters/skus-supplier-filter': typeof FiltersSkusSupplierFilterComponent;
  }
}
